import { EMPTY_DIRECT_DATA_INPUT_MODEL } from "presentation/model/DirectDataInput/DirectDataInputModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: DirectDataInputProvider,
    useTracked: useDirectDataInputTracked
} = createContainer(() => useState(EMPTY_DIRECT_DATA_INPUT_MODEL), { concurrentMode: true });
export { DirectDataInputProvider, useDirectDataInputTracked };

